import {useState, useRef} from "react"
import {NavLink} from "react-router-dom"
import i18n from "../../i18n/i18n"
import logout from "../../aws/cognito/logout"
import franceFlagImg from "../../assets/img/france.svg"
import englandFlagimg from "../../assets/img/england.svg"
import arrowDownBlack from "../../assets/icon/arrow-down-black.svg"
import logoutIcon from "../../assets/icon/logout.svg"
import ProfilePicture from "../../components/profile-picture/ProfilePicture"
import {useTranslation} from "react-i18next"
import {useLocalContext} from "../../reactContext/contextCustomHooks/useLocalContext"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import useClickOutside from "../../tools/useClickOutside"

export default function Header() {
    const {t} = useTranslation()
    const {localContext, setLocalAction} = useLocalContext()
    const {setSessionAction} = useSessionContext()
    const {setTeamAction} = useTeamContext()
    const [langsMenu, setLangMenu] = useState(false)
    const langsMenuref = useRef(null)

    useClickOutside(langsMenuref, () => {
        document.getElementById("arrow").style.transform = "rotate(0deg)"
        setLangMenu(false)
    })

    const handleClick = () => {
        document.getElementById("arrow").style.transform = langsMenu ? "rotate(0deg)" : "rotate(180deg)"
        setLangMenu(!langsMenu)
    }

    const setLang = (language) => {
        handleClick()
        setLocalAction({type: "SET_LANG", payload: {lang: language}})
        i18n.changeLanguage(language)
    }

    const disconnect = async () => {
        await logout().then(() => {
            setSessionAction({type: "LOGOUT"})
            setTeamAction({type: "CLEAN_TEAM_CONTEXT"})
        })
    }

    return (
        <>
        <header className="SECTION HEADER">
            <nav className="nw-header-nav">
                <ul>
                    <ul ref={langsMenuref} className="langs" style={{borderRadius: `${langsMenu ? "18px" : "36px"}`}} title={t("Select your language")}>
                        {localContext.lang === "fr-FR" ?
                            <li onClick={() => setLang("fr-FR")} className="lang"><img className="flag" src={franceFlagImg} alt=""/>FR</li>
                            :
                            <li onClick={() => setLang("en-US")} className="lang"><img className="flag" src={englandFlagimg} alt=""/>EN</li>
                        }
                        {langsMenu ?
                            localContext.lang === "fr-FR" ?
                                <li onClick={() => setLang("en-US")} className="lang"><img className="flag" src={englandFlagimg} alt=""/>EN</li>
                                :
                                <li onClick={() => setLang("fr-FR")} className="lang"><img className="flag" src={franceFlagImg} alt=""/>FR</li>
                        : ""}
                        <img onClick={handleClick} id="arrow" className="arrow" src={arrowDownBlack} alt=""/>
                    </ul>
                    <li title={t("Profile")}><NavLink to="/profile"><ProfilePicture/></NavLink></li>
                    <li className="logout" onClick={disconnect} title={t("Disconnect")}><img src={logoutIcon} alt=""/></li>
                </ul>
            </nav>
        </header>
        </>
    )
}